/** @typedef {'en' | 'ru' | 'es' | 'fr' | 'zh' | 'hi'} UiLocale */

/** @type {readonly UiLocale[]} */
export const SUPPORTED_UI_LOCALES = ['en', 'ru', 'es', 'fr', 'zh', 'hi'];

export const DEFAULT_UI_LOCALE = /** @type {const} */ ('en');

/** @type {Record<UiLocale, string>} */
export const UI_LOCALE_LABELS = {
  en: 'English',
  ru: 'Русский',
  es: 'Español',
  fr: 'Français',
  zh: '中文',
  hi: 'हिन्दी',
};

/**
 * @param {string | null | undefined} value
 * @returns {UiLocale}
 */
export function normalizeUiLocale(value) {
  if (value && SUPPORTED_UI_LOCALES.includes(/** @type {UiLocale} */ (value))) {
    return /** @type {UiLocale} */ (value);
  }
  return DEFAULT_UI_LOCALE;
}

/**
 * @param {UiLocale | string | null | undefined} locale
 */
export function applyDocumentLocale(locale) {
  const lang = normalizeUiLocale(locale);
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lang;
  }
  return lang;
}
